import { useEffect } from 'react';
import { Text } from '@fluentui/react-components';

export default function SettingsLocations() {
  useEffect(() => {
    window.dispatchEvent(new CustomEvent('setPageContext', {
      detail: { title: 'Locations' },
    }));
    return () => {
      window.dispatchEvent(new CustomEvent('setPageContext', { detail: null }));
    };
  }, []);

  return (
    <div style={{ padding: '1rem' }}>
      <Text>Configure location settings here.</Text>
    </div>
  );
}
